export default __webpack_public_path__ + "static/People_Placeholder_3.0@2x-d374c0bd1d493a1b91a2949ff334eab6.jpg";